import React from 'react';

function SidebarBottom() {
  return (
    <div className="admin-layout-sidebar-bottom">
    </div>
  );
}

export default SidebarBottom;
